const GOOGLE_IDENTITY_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

let scriptPromise = null;

const ensureGoogleIdentityServices = () => {
  if (window.google && window.google.accounts && window.google.accounts.oauth2) {
    return Promise.resolve(window.google);
  }

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = GOOGLE_IDENTITY_SCRIPT_SRC;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        if (window.google && window.google.accounts && window.google.accounts.oauth2) {
          resolve(window.google);
        } else {
          reject(new Error("Google Identity Services did not initialize correctly."));
        }
      };

      script.onerror = () => reject(new Error("Failed to load Google Identity Services."));

      document.head.appendChild(script);
    });
  }

  return scriptPromise;
};

export const loadGoogleIdentityServices = () => ensureGoogleIdentityServices();

export const requestGoogleAccessToken = () => {
  return ensureGoogleIdentityServices().then((google) => {
    return new Promise((resolve, reject) => {
      const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "1044884356149-g9de3qc5e72mu91phajg5c4ja67k4tdf.apps.googleusercontent.com";

      if (!clientId) {
        reject(new Error("Google client ID is not configured."));
        return;
      }

      const tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: "openid email profile https://www.googleapis.com/auth/userinfo.email",
        prompt: "select_account",
        callback: (response) => {
          if (response && response.access_token) {
            resolve(response);
          } else {
            reject(new Error("Google authentication failed. No access token received."));
          }
        },
        error_callback: (error) => {
          const message =
            error?.error_description || error?.error || "Google authentication failed.";
          const enrichedError = new Error(message);
          enrichedError.code = error?.error;
          reject(enrichedError);
        },
      });

      tokenClient.requestAccessToken();
    });
  });
};
